/**
 * "Leggi di più" per la descrizione prodotto (PDP)
 *
 * Tronca la descrizione dopo un numero configurabile di paragrafi e mostra un
 * link "leggi di più" che, al click, espande l'intera descrizione.
 *
 * Il comportamento si attiva sui contenitori con attributo `data-read-more`:
 *   - data-read-more-paragraphs : numero di paragrafi visibili (default 2)
 *   - data-read-more-label      : etichetta del link (già tradotta lato Liquid)
 *
 * Vedi il blocco "description" in sections/main-product.liquid.
 */

const HIDDEN_CLASS = 'product-description__paragraph--hidden';
const EXPANDED_CLASS = 'is-expanded';
const INIT_ATTR = 'data-read-more-init';

/**
 * Individua l'elemento che contiene effettivamente i paragrafi.
 * Con l'icona attiva la descrizione è annidata dentro `.with-icon__beside`.
 */
function getContentRoot(container) {
  return container.querySelector('.with-icon__beside') || container;
}

/**
 * Restituisce i "paragrafi" di primo livello da usare per il troncamento.
 * Preferisce i <p> diretti; in mancanza, ripiega sui figli di tipo elemento.
 */
function getParagraphs(root) {
  const paragraphs = Array.from(root.querySelectorAll(':scope > p'));
  if (paragraphs.length) return paragraphs;

  return Array.from(root.children).filter(
    (node) => node.nodeType === Node.ELEMENT_NODE
  );
}

function initContainer(container) {
  if (container.hasAttribute(INIT_ATTR)) return;

  const root = getContentRoot(container);
  const limit = parseInt(container.dataset.readMoreParagraphs, 10) || 2;
  const label = (container.dataset.readMoreLabel || '').trim() || 'Leggi di più';

  const paragraphs = getParagraphs(root);

  // Niente da troncare: meno paragrafi del limite.
  if (paragraphs.length <= limit) return;

  container.setAttribute(INIT_ATTR, '');

  const hidden = paragraphs.slice(limit);
  hidden.forEach((el) => el.classList.add(HIDDEN_CLASS));

  const trigger = document.createElement('button');
  trigger.type = 'button';
  trigger.className = 'product-description__read-more';
  trigger.textContent = label;

  trigger.addEventListener('click', () => {
    hidden.forEach((el) => el.classList.remove(HIDDEN_CLASS));
    container.classList.add(EXPANDED_CLASS);
    trigger.remove();
  });

  // Il link va inserito subito dopo il contenuto (dentro lo stesso root).
  root.appendChild(trigger);
}

function initAll(scope = document) {
  scope.querySelectorAll('[data-read-more]').forEach(initContainer);
}

function ready(fn) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fn);
  } else {
    fn();
  }
}

ready(() => initAll());

// Re-init quando Shopify ricarica la section nell'editor del tema.
document.addEventListener('shopify:section:load', (event) => {
  initAll(event.target || document);
});
